import { useState, useEffect} from 'react';
import { isPointInPolygon } from 'geolib';

export function usePropertiesInViewport(properties, viewport) {
  let [ hash, setHash ] = useState('');
  let [ bounded, setBounded ] = useState([]);
  let [ viewported, setViewported ] = useState([]);
  let [ highlighted, setHighlighted ] = useState([]);

  useEffect(() => {
    if (!viewport || !properties.length) {
      setViewported([]);
      setHash('');
      return;
    }

    let polygon = [
      { latitude: viewport._ne.lat, longitude: viewport._ne.lng },
      { latitude: viewport._ne.lat, longitude: viewport._sw.lng },
      { latitude: viewport._sw.lat, longitude: viewport._sw.lng },
      { latitude: viewport._sw.lat, longitude: viewport._ne.lng },
    ];

    let newBounded = properties.filter(x => isPointInPolygon({ latitude: x.coords[0], longitude: x.coords[1] }, polygon));
    let newHighlighted = highlighted.filter(x => newBounded.some(y => y.id === x.id));

    if (newHighlighted.length !== highlighted.length) {
      setHighlighted(newHighlighted);
    }

    let newViewported = newBounded.filter(x => !highlighted.some(y => y.id === x.id));

    let newHash = newViewported.map(x => x.id).join('');

    if (newHash === hash) return;

    setHash(newHash);
    setViewported(newViewported);
    setBounded(newBounded);
  }, [properties, viewport, highlighted]);

  return {
    boundedProperties: bounded,
    viewportedProperties: viewported,
    highlightedProperties: highlighted,
    highlightProperties: setHighlighted,
  };
}
